import { createReducer } from '@reduxjs/toolkit';
import {
  cardForSaleError, cardForSalePurchased,
  cardForSalePurchaseError,
  cardForSaleReset,
  cardForSaleSuccess,
  cardFromSaleRemoving,
  cardSaleSetCardProgress,
} from './saleCardActions';

export type SaleCardStates = 'success' | 'error' | 'purchaseError' | 'purchased' | 'initial' | 'removing';

interface SaleCardState {
  state: SaleCardStates
  cardsInProgress: { [key: number]: boolean },
}

const initialState: SaleCardState = {
  state: 'initial',
  cardsInProgress: {},
};

const saleCardReducer = createReducer(
  initialState,
  (builder) => {
    builder
      .addCase(cardForSaleError, (state) => {
        state.state = 'error';
      })
      .addCase(cardForSalePurchaseError, (state) => {
        state.state = 'purchaseError';
      })
      .addCase(cardForSaleSuccess, (state) => {
        state.state = 'success';
      })
      .addCase(cardFromSaleRemoving, (state) => {
        state.state = 'removing';
      })
      .addCase(cardForSaleReset, (state) => {
        state.state = 'initial';
      })
      .addCase(cardForSalePurchased, (state) => {
        state.state = 'purchased';
      })
      .addCase(cardSaleSetCardProgress, (state, { payload: { nftItemId, inProgress } }) => {
        state.cardsInProgress[nftItemId] = inProgress;
      });
  },
);

export default saleCardReducer;
